import { usersSlice } from './slice';
export const { putAll, added, addedAll } = usersSlice.actions;
